export class ScrollService {
    scrollToVote() {
        const voteElement = document.querySelector('#vote');

        if (!voteElement) {
            return;
        }

        const y = voteElement.getBoundingClientRect().top + window.pageYOffset + -80;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };

    scrollToCustomize() {
        const customizeElement = document.querySelector('#customize');

        if (!customizeElement) {
            return;
        }

        const y = customizeElement.getBoundingClientRect().top + window.pageYOffset + -80;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };

    scrollToElement(element: HTMLElement) {
        const y = element.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };
}
